import React from 'react';
import { Shield, Users } from 'lucide-react';
import {
  LANDING_COMMISSIONER_BENEFITS,
  LANDING_MEMBER_BENEFITS,
  LANDING_SECTION_BENEFITS,
} from '../../landing/landingCopy';

const LscLandingBenefits: React.FC = () => {
  return (
    <section className="space-y-8" data-testid="lsc-landing-benefits">
      <div className="text-center space-y-3">
        <h2 className="text-2xl md:text-3xl font-bold text-white">{LANDING_SECTION_BENEFITS}</h2>
        <p className="text-secondary-400 max-w-2xl mx-auto">
          One hub with the right tools in the right places.
        </p>
      </div>
      <div className="grid gap-6 md:grid-cols-2">
        <article
          className="rounded-xl border border-secondary-700/80 bg-gradient-to-br from-secondary-800/70 to-secondary-900/90 p-6 space-y-4 shadow-lg"
          data-testid="lsc-landing-commissioner-benefits"
        >
          <div className="flex items-center gap-3">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary-900/40 text-primary-300">
              <Shield className="h-5 w-5" aria-hidden />
            </span>
            <h3 className="text-lg font-semibold text-white">Commissioners</h3>
          </div>
          <ul className="space-y-2.5 text-sm text-secondary-300">
            {LANDING_COMMISSIONER_BENEFITS.map((item) => (
              <li key={item} className="flex gap-2.5">
                <span className="text-primary-400 mt-0.5" aria-hidden>
                  •
                </span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </article>
        <article
          className="rounded-xl border border-secondary-700/80 bg-gradient-to-br from-secondary-800/70 to-secondary-900/90 p-6 space-y-4 shadow-lg"
          data-testid="lsc-landing-member-benefits"
        >
          <div className="flex items-center gap-3">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary-900/40 text-primary-300">
              <Users className="h-5 w-5" aria-hidden />
            </span>
            <h3 className="text-lg font-semibold text-white">Members</h3>
          </div>
          <ul className="space-y-2.5 text-sm text-secondary-300">
            {LANDING_MEMBER_BENEFITS.map((item) => (
              <li key={item} className="flex gap-2.5">
                <span className="text-primary-400 mt-0.5" aria-hidden>
                  •
                </span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </article>
      </div>
    </section>
  );
};

export default LscLandingBenefits;
